export default __webpack_public_path__ + "static/media/scale_active.46c54192.svg";